module.exports = __webpack_public_path__ + "media/courses/curricula/images/course-ended-9b5ff5460567ea931053591ccac1d149.svg";